import React, { Component, PropTypes } from 'react';
import Image from '../components/Image';


export default class OrganizationDetailBanner extends Component {
  state = {
    name: null,
    icon: null,
    iconDataURI: null,
    coverDataURI: null,
    cover: null,
    showEditName: false
  };

  constructor(props) {
    super(props);
  }

  handleImage = (key, file) => {
    let reader = new FileReader();
    reader.onload = (upload) => {
      let ns = {};
      ns[`${key}DataURI`] = upload.target.result;
      ns[key] = file;
      this.setState(ns);
    };
    reader.readAsDataURL(file);
  };

  updateIcon = e => {
    let file = e.target.files[0];
    this.handleImage('icon', file);
    this.props.updateContent('image_icon', file);
  };

  updateCover = e => {
    let file = e.target.files[0];
    this.handleImage('cover', file);
    this.props.updateContent('image_cover', file);
  };

  updateName = e => {
    this.setState({ name: e.target.value });
  };

  updateIconImage = e => {
    let getEvent = () => {
      let obj = {};
      for(const key in e) {
        obj[key] = e[key];
      }
      return obj;
    };
    event = getEvent();
  };

  cancelEdit = e => {
    this.setState({ name: null });
    this.hideEditName();
  };

  hideEditName = e => {
    this.setState({ showEditName: false });
  };

  showEditName = e => {
    this.setState({ showEditName: true });
  };

  saveContent = e => {
    if(this.state.name !== null) {
      this.props.updateContent('name', this.state.name);
    }
    if(this.state.icon !== null) {
      this.props.updateContent('image_icon', this.state.icon);
    }
    if(this.state.cover !== null)  {
      this.props.updateContent('image_cover', this.state.cover);
    }
    this.hideEditName();
  };

  render() {
    const { browser, organization } = this.props;
    let coverImageSrc = `thumbnails/?model=organization&id=${organization.db_id}&size=850x315&source=image_cover`;
    let iconImageSrc = `thumbnails/?model=organization&id=${organization.db_id}&size=100x100&source=image_icon`;



    let editCoverIcon = '';
    let editIconIcon = '';
    let editNameIcon = '';
    let orgName = '';

    let iconImageDataURI = null;
    if(this.state.iconDataURI) {
      iconImageDataURI = this.state.iconDataURI;
    }

    let coverImageDataURI = null;
    if(this.state.coverDataURI) {
      coverImageDataURI = this.state.coverDataURI;
    }


    if(this.props.isEditMode) {
      editCoverIcon = <span className="organization-editCoverIcon">
        <i className="fa fa-camera"></i> Upload new banner (850 pixels X 315 pixels)
        <input onChange={this.updateCover} name="image_cover" type="file" />
      </span>;
      editIconIcon = <span className="organization-editIconIcon">
        <i className="fa fa-camera"></i><span>Upload new logo (100 pixels X 100 pixels)</span>
        <input onChange={this.updateIcon} name="image_icon" type="file" />
      </span>;
      editNameIcon = <span onClick={this.showEditName} className="organization-editNameIcon">
        <i className="fa fa-pencil"></i>
      </span>;

    }

    let orgNameValue = this.state.name || organization.name;
    if(this.state.showEditName) {
      orgName = <div className="organizationDetail-name">
        <input type="text" name="name" defaultValue={orgNameValue} onChange={this.updateName} />
        <button onClick={this.saveContent}>Save</button> <button onClick={this.cancelEdit}>Cancel</button>
      </div>;
    }
    else {
      orgName = <div className="organizationDetail-name">
            {orgNameValue}
            {editNameIcon}
          </div>;
    }

    if(browser.greaterThan.desktop) {
      return (
        <div className="organizationDetail-coverSection">
          <div className="organizationDetail-iconNameContainer">
            {editIconIcon}
            <Image dataURI={iconImageDataURI} className="organizationDetail-iconImage" src={iconImageSrc} />
              {orgName}
          </div>
          <div className="organizationDetail-coverImageContainer">
            {editCoverIcon}
            <Image dataURI={coverImageDataURI} className="organizationDetail-coverImage" src={coverImageSrc} />
          </div>
        </div>
      );
    }
    else {
      return (
        <div>
          {editCoverIcon}
          <Image dataURI={coverImageDataURI} className="organizationDetail-coverImage" src={coverImageSrc} />
          <div className="organizationDetail-iconNameContainer">
            {orgName}
            <Image dataURI={iconImageDataURI} className="organizationDetail-iconImage" src={iconImageSrc} />
            {editIconIcon}
          </div>
        </div>
      );
    }

    return coverSection;
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganizationDetailBanner.jsx